var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33337 4C8.2288 4 7.33337 4.89543 7.33337 6V20L12 15.3333L16.6667 20V6C16.6667 4.89543 15.7713 4 14.6667 4H9.33337ZM13.0402 7.50204L15.3334 7.85867L13.6937 9.5791L14.0793 11.9789L12.014 10.8735L9.95905 12L10.3223 9.59636L8.66671 7.89281L10.9565 7.51273L11.9882 5.33333L13.0402 7.50204Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/Favourite.5cc56eaed7da80cb8ecca6d73e381a6e.svg";
export { ForwardRef as ReactComponent };